import PackagingBaseScreen from "../../shared/packaging/PackagingBaseScreen";
import Packaging from "./Packaging";
import PackagingMethod from "./PackagingMethod";

export const FarmGatePackagingBase = ({ modalData }: { modalData: any }) => (
  <PackagingBaseScreen
    gate="farm-gate"
    modalData={modalData}
    Packaging={Packaging}
    PackagingMethod={PackagingMethod}
  />
);
